import * as React from 'react';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import Stack from '@mui/material/Stack';
import { chartColors } from '../constants';
import { formatNumberWithCommas } from '../utils/formatNumberWithCommas';

export default function PieChartData({
  items,
  width = 600,
  windowWidth
}) {

  const colors = items.map((_, index) => chartColors[index % chartColors.length]);
  const isSmallScreen = windowWidth <= 768;

  return (
    
    <Stack direction={{ xs: 'column' }} alignItems={{ xs: 'flex-start' }}>
      <PieChart
        colors={colors}
        series={[
          {
            data: items,
            innerRadius: 30,
            outerRadius: 100,
            paddingAngle: 0,
            cornerRadius: 6,
            startAngle: -117,
            endAngle: 242,
            cx: 150,
            cy: 150,
            arcLabel: (item) => `${formatNumberWithCommas(item.value)}`,
            arcLabelMinAngle: 30,
            arcLabelRadius: items.length > 12 ? '45%' : '45%',
          }
        ]}
        width={width}
        height={300}
        slotProps={{
          legend: {
            sx: {
              overflowY: 'scroll',
              flexWrap: 'nowrap',
              height: '100%',
            },
            labelStyle: {
              fontSize: 14,
            },
            itemMarkWidth: 35,
            itemMarkHeight: 7,
            markGap: 8,
            itemGap: 10,
          },
        }}
        label={({ data }) => `${data.label} (${data.value})`}
        sx={{
          [`& .${pieArcLabelClasses.root}`]: {
            fontSize: 14,
          },
        }}
      />
    </Stack>
  );
}
